import axios from 'axios';
import Swal from 'sweetalert2';

export default class ShortlistNew {

  init($) {
    this.api = axios.create({
      baseURL: process.env.NODE_ENV === 'test' ? 'http://hip.test/' : '/'
    });

    $('body').on('click', '.new-shortlist-btn', (event) => {
      const element = $(event.currentTarget);
      const requestBody = {
        userId: element.attr('data-user-id'),
        entityId: element.attr('data-entity-id'),
        entityType: element.attr('data-entity-type'),
        shortListId: element.attr('data-short-list-id'),
        siteId: element.attr('data-site-id')
      };

      if (element.attr('data-action') === 'add') {
        this.addToShortlist(requestBody)
          .then((response) => {
            requestBody.shortListId = response.data.shortListId;
            this.updateShortlistButton(requestBody, 'add');
          })
          .catch((error) => {
            Swal.fire({
              title: 'Error',
              text: error.message,
              type: 'error',
              showCloseButton: true,
              confirmButtonText: 'Close'
            });
          });
      } else if (element.attr('data-action') === 'remove') {
        this.removeFromShortlist(requestBody)
          .then((response) => {
            requestBody.shortListId = response.data.shortListId;
            this.updateShortlistButton(requestBody, 'remove');
          })
          .catch((error) => {
            Swal.fire({
              title: 'Error',
              text: error.message,
              type: 'error',
              showCloseButton: true,
              confirmButtonText: 'Close'
            });
          });
      }
    });
  }

  addToShortlist(requestBody) {
    return new Promise((resolve, reject) => {
      this.api.put('/v2/shortlist', requestBody).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error.response.data);
      });
    });
  }

  removeFromShortlist(requestBody) {
    return new Promise((resolve, reject) => {
      this.api.post('/v2/shortlist/remove', requestBody).then((response) => {
        resolve(response.data);
      }).catch((error) => {
        reject(error.response.data);
      });
    });
  }

  updateShortlistButton(data, action) {
    const element = document.getElementById(`shortlist-button-${data.siteId}-${data.entityId}`);
    if (element === null) {
      return;
    }
    if (action === 'add') {
      element.innerHTML = '<span class="icon"><i class="hui-icon-heart"></i></span>';
      element.setAttribute('data-action', 'remove');
    } else if (action === 'remove') {
      element.innerHTML = '<span class="icon"><i class="hui-icon-heart-o"></i></span>';
      element.setAttribute('data-action', 'add');
    }

    element.setAttribute('data-user-id', data.userId);
    element.setAttribute('data-short-list-id', data.shortListId);
  }
}



// WEBPACK FOOTER //
// ./_common/scripts/shortlist-new.js